import { ReactNode } from 'react';
import { createCtx } from '@shared/util/context';

export interface ShowModalOptions {
  title: string;
  description: string;
  header?: ReactNode;
  hideUpgradeButton?: boolean;
  onLearnMore?: () => void;
}

interface UpgradeModalAPI {
  show(data: ShowModalOptions): void;
}

export const [useUpgradeModal, UpgradeModalContextProvider] = createCtx<UpgradeModalAPI>();
